import { createSelector } from 'reselect'

const getUserData = state => state.user
const getMyAccountData = state => state.myAccount

const advancedViewSelector = createSelector(
	[ getUserData, getMyAccountData ],
	(userData, myAccountData) => ({
		advancedSettings: myAccountData.advancedSettings,
		intercomIO: userData.data.intercomIO,
	})
)

export default advancedViewSelector
